<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>日志管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="用户名"
          class="s-input separate"
          v-model="queryInfo.username"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.role"
        >
          <option value="">操作角色</option>
          <option
            v-for="(val,key) in dict_role"
            :key="key"
            :value="key"
          >
            {{val}}
          </option>
        </select>
        <select
          class="s-select separate"
          v-model="queryInfo.category"
        >
          <option value="">操作类型</option>
          <option
            v-for="(val,key) in dict_log_type"
            :key="key"
            :value="key"
          >
            {{val}}
          </option>
        </select>
        <input
          type="date"
          class="s-input separate"
          v-model="queryInfo.created"
        >
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
      </form>
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>用户名</th>
            <th>角色</th>
            <th>操作类型</th>
            <th>操作日期</th>
            <th>操作详情</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.userprofile.username}}</td>
            <td>{{all_role[item.userprofile.role]}}</td>
            <td>{{dict_log_type[item.category]}}</td>
            <td>{{formatTime(item.created)}}</td>
            <td>{{item.content}}</td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>

  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Feedback',
  components: {
    Pagination
  },
  data() {
    return {
      classShowFeedBackWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        username: '',
        role: '',
        category: '',
        created: ''
      },
      tableData: [],
      tableDataCount: 0
    }
  },
  // 计算属性
  computed: {
    dict_role() {
      if (this.$store.state.platform_level === 3) {
        return {
          3: '校管理员',
          4: '院系管理员',
          10: '运营管理员',
          11: '教师',
          12: '学生'
        }
      } else if (this.$store.state.platform_level === 4) {
        return {
          4: '院系管理员',
          10: '运营管理员',
          11: '教师',
          12: '学生'
        }
      } else {
        return {}
      }
    },
    all_role() {
      return this.$store.state.dict_role
    },
    dict_log_type() {
      return this.$store.state.dict_log_type
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    formatTime(val) {
      return val.replace('T', ' ').substring(0, val.indexOf('.'))
    },
    async search() {
      await this.$http.get('/user_log/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style lang="less" scoped>
</style>
